<template>
  <div class="mb-4">
    <label :for="label" class="block text-sm leading-5 font-medium text-gray-700 mb-1"
      >{{ label }} <span v-if="optional" class="text-xs text-gray-700">(optional)</span></label
    >
    <div class="mt-1">
      <input
        :id="label"
        v-model="textValue"
        autocomplete="new-password"
        type="password"
        class="focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md field-sizing-fixed"
        :placeholder="placeholder"
        @input="$emit('update:modelValue', $event.target.value)"
        @blur="$emit('blur', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ['modelValue', 'label', 'placeholder', 'optional', 'disabled'],
  data() {
    return {
      textValue: this.modelValue,
    };
  },
  watch: {
    modelValue(newVal) {
      this.textValue = newVal;
    },
  },
};
</script>
